<template>
  <CRow class="py-5 mt-4">
    <CCol xs="12" sm="12">
      <div>
        <h1 class="titlePage font-weight-bold text-capitalize mb-4 h2">
          {{ $t('settings.api.title') }}
        </h1>
      </div>
    </CCol>
    <CCol>
      <template v-if="messages.length">
        <transition name="fade">
          <MenssageAlert :messages="messages" />
        </transition>
      </template>
    </CCol>
    <CCol xs="12" sm="12">
      <CRow>
        <CCol xs="12" sm="12" v-if="apiKey">
          <CCard class="apiCard">
            <CCardHeader class="py-3">
              <div class="d-flex justify-content-between content-center">
                <h2 class="h4">
                  {{ $t('settings.api.apiCard.title') }}
                </h2>
                <CButton target="_blank" :href="$configs.VUE_APP_DOCS_URL" class="btn-outline-primary">
                  <CIcon name="book" :height="17" class="mr-3" viewBox="0 0 32 32" />

                  {{ $t('settings.api.apiCard.link-doc') }}
                </CButton>
              </div>
            </CCardHeader>
            <CCardBody>
              <CRow class="my-3 p-4">
                <CCol sm="12" md="6">
                  <form class="d-flex flex-column justify-content-between h-100 pr-4">
                    <CInput
                      class="newInput inputAppendCustom"
                      :label="$t('settings.api.input.key.label')"
                      type="text"
                      readonly
                      :value="valueApi"
                      :description="descriptionSuccessKey"
                    >
                      <template #append-content>
                        <CButton @click="blockKey('key')">
                          <i class="far" :class="`fa-${iconEye}`"></i>
                        </CButton>
                        <CButton
                          :data-clipboard-text="apiKey"
                          class="clip"
                          v-c-tooltip.hover.click="{
                            content: 'copy',
                            placement: 'top',
                          }"
                        >
                          <CIcon class="btn-values" name="copy" size="custom-size" :height="19" viewBox="0 0 32 32" />
                        </CButton>
                      </template>
                    </CInput>
                    <CInput
                      :isValid="true"
                      class="newInput inputAppendCustom mt-3"
                      :label="$t('settings.api.input.organizationId.label')"
                      type="text"
                      readonly
                      add-input-classes="clip"
                      :description="descriptionSuccessOrganizationId"
                      :value="organizationId"
                    >
                      <template #append-content>
                        <CButton
                          v-c-tooltip.hover.click="{
                            content: 'Copy',
                            placement: 'top',
                          }"
                          :data-clipboard-text="organizationId"
                          class="clip"
                        >
                          <CIcon class="btn-values" name="copy" size="custom-size" :height="19" viewBox="0 0 32 32" />
                        </CButton>
                      </template>
                    </CInput>
                  </form>
                </CCol>
                <CCol sm="12" md="6" class="d-flex border-gray-200 rounded px-3 py-4">
                  <CCol sm="12" md="8">
                    <h5 class="mb-3 font-lg">
                      {{ $t('settings.api.box-desciption.title') }}
                    </h5>
                    <p class="text-gray-500 font-sm">
                      {{ $t('settings.api.box-desciption.description') }}
                    </p>
                  </CCol>
                  <CCol sm="12" md="4">
                    <figure>
                      <!-- <img src="/img/site/amico-security.png" width="100%" alt="" /> -->
                      <img src="@/assets/svg/WithAPIKey.svg" />
                    </figure>
                  </CCol>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
        <CCol xs="12" sm="12" class="h-50" v-else>
          <CCard class="apiCard">
            <CCardBody class="p-5">
              <div class="d-flex justify-content-center align-items-center" v-if="loading" style="min-height: 300px">
                <CSpinner color="custom-color" />
              </div>
              <CRow class="my-3 p-4" v-else>
                <CCol sm="12" md="12" class="">
                  <CRow>
                    <CCol sm="12" class="text-center">
                      <figure>
                        <!-- <img src="/img/site/amico-work.png" alt="" /> -->
                        <img src="@/assets/svg/NoAPIKey.svg" />
                      </figure>
                    </CCol>

                    <CCol sm="4" class="offset-sm-4 text-center">
                      <h5 class="mb-3 font-lg">
                        {{ $t('settings.api.box-empty.title') }}
                      </h5>
                      <p class="text-gray-500 font-sm">
                        {{ $t('settings.api.box-empty.description') }}
                      </p>
                      <CButton color="primary" size="md" @click="generateApiKey">
                        {{ $t('settings.api.box-empty.button.generate-key') }}
                      </CButton>
                    </CCol>
                  </CRow>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CCol>
  </CRow>
</template>

<script>
import ClipboardJS from 'clipboard'
import services from '@/services.js'
import MenssageAlert from '@/components/MenssageAlert'

export default {
  name: 'APIPage',
  components: {
    MenssageAlert,
  },
  data() {
    return {
      loading: false,
      messages: [],
      organizationId: null,
      valueApi: '',
      apiKey: '',
      key: 'text',
      secret: '••••••••••••••••••••••••••••••••••••••',
      descriptionSuccessKey: '',
      descriptionSuccessOrganizationId: '',
    }
  },

  mounted() {
    this.organizationId = this.$route.params.organizationId

    this.blockKey()
    var clipboard = new ClipboardJS('.clip')
    var that = this

    clipboard.on('success', function (e) {
      if (e) {
        that.messageSuccess(e.text)
      }
      e.clearSelection()
    })

    this.getApi()
  },
  computed: {
    iconEye() {
      return this.key === 'password' ? 'eye-slash' : 'eye'
    },
    userId() {
      return this.$store.getters['auth/IdUser']
    },
  },
  methods: {
    getApi() {
      this.loading = true

      services
        .getApiKey({ userId: this.userId })
        .then(({ data }) => {
          if (!data.data) {
            return
          }

          this.apiKey = data.data.apiKey
        })
        .catch((error) => {
          this.messages.push({
            status: 'danger',
            text: error.response.data.message,
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    generateApiKey() {
      this.loading = true
      services
        .postApiKey({ userId: this.userId })
        .then(({ data }) => {
          if (!data.data) {
            return
          }
          this.apiKey = data.data.apiKey
        })
        .catch((error) => {
          this.messages.push({
            status: 'danger',
            text: error.response.data.message,
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    blockKey() {
      if (this.key == 'password') {
        this.valueApi = `${this.apiKey}`
        this.key = 'text'
      } else {
        this.key = 'password'
        this.valueApi = `${this.secret}${this.apiKey.slice(-4)}`
      }
    },

    messageSuccess(value) {
      if (this.organizationId === value) {
        this.descriptionSuccessOrganizationId = 'copied'
      }

      if (this.apiKey === value) {
        this.descriptionSuccessKey = 'copied'
      }

      setTimeout(() => {
        this.descriptionSuccessKey = ''
        this.descriptionSuccessOrganizationId = ''
      }, 2000)
    },
  },
}
</script>

<style lang="scss">
.text-muted {
  color: $success;
  text-align: right;
}
</style>
